import { AxiosResponse, AxiosError, AxiosRequestConfig } from 'axios'
import _get from 'lodash/get'
import * as Analytics from 'core/common/analytics'
import EHttpStatus from 'core/common/constants/http'
import * as Error from 'core/common/utils/error'

export const onResponseError = (error: AxiosError) => {
  if (error.response && error.response.status === EHttpStatus.Unauthorized) {
    window.location.reload()
  } else {
    const message = Error.message(error)
    Analytics.catchEventApi({ message })
  }

  return Promise.reject(error)
}

export const onResponseSuccess = (response: AxiosResponse) => {
  let pagination = _get(response.headers, 'x-pagination', null)

  if (pagination) {
    pagination = JSON.parse(pagination.replace(/'/g, '"').toLocaleLowerCase())
  }

  return {
    ...response,
    pagination,
  }
}

export const setHeaders = (reqConfig: AxiosRequestConfig) => {
  const hydratedConfig = reqConfig
  const token = localStorage.getItem('token')
  const tenant = localStorage.getItem('tenant')
  const channel = localStorage.getItem('channel')

  if (hydratedConfig.headers) {
    hydratedConfig.headers.Authorization = `Bearer ${token}`
    hydratedConfig.headers['x-tenant-id'] = tenant || ''
    hydratedConfig.headers['x-channel'] = channel || ''
  }

  return hydratedConfig
}
